import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function ShippingReturns() {
  return (
    <LegalPage
      testid="shipping-returns-page"
      eyebrow="Legal"
      title="Shipping & Returns"
      sections={[
        { h: "Processing time", p: "Orders are typically processed within 2–4 business days. You will receive a confirmation once your order ships." },
        { h: "Shipping", p: "We ship domestically and internationally. Delivery times and rates are calculated at checkout based on your location." },
        { h: "Returns", p: "Unworn, unwashed apparel may be returned within 30 days of delivery for a refund or exchange. Music and digital items are non-refundable." },
        { h: "Damaged items", p: "If your order arrives damaged, email hello@heartnsoulrecords.com with a photo and we will make it right." },
      ]}
    />
  );
}
